import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { ConfigService } from '../../../services/config/config.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class MdrInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private configService: ConfigService, private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.configService.isMaintenance) {
            this.router.navigate(['maintenance']).catch(console.error);
        }

        if (
            (!window.location.href.includes('sign-up') || !window.location.href.includes('login')) &&
            !window.location.href.includes('maintenance')
        ) {
            let getParams = request.params;
            let trackingId = uuidv4();

            if (!getParams) {
                getParams = new HttpParams();
            }
            getParams = getParams.append('tz_offset', String(new Date().getTimezoneOffset() / 60));

            const source_cid = this.authService.jwtUser?.CompanyId;

            if (source_cid === undefined || source_cid === null) {
                return next.handle(request);
            }

            let target_cid = source_cid;
            if (getParams.has('cid')) {
                target_cid = String(getParams.get('cid'));
            }

            const reqClone = request.clone({
                params: getParams,
                setHeaders: {
                    'source-company-id': source_cid,
                    'target-company-id': target_cid,
                    'x-request-id': trackingId,
                },
            });

            return next.handle(reqClone);
        }

        return next.handle(request);
    }
}
